import Vue from "vue";
import JWTService from "../service/jwt.service";
import Notifier from "./notifier";
import store from "@/store";
import createResources from "@/common/utils/create-resources";

import dayjs from "dayjs";
import ru from "dayjs/locale/ru";

dayjs.locale(ru);

const plugins = {
  install(Vue) {
    Vue.mixin({
      computed: {
        $jwt: () => JWTService,
        $notifier: () => new Notifier(store),
        $api() {
          return createResources(this.$notifier);
        },
        $dayjs: () => dayjs,
      },
    });
  },
};

Vue.use(plugins);
